import Backbone from 'backbone';
import {SELECTION_CHANGED} from 'common/constants';

Backbone.$ = $;

export default Backbone.View.extend({
  constructor(...args) {
    this.$options = undefined;
    this.$selected = undefined;
    this.periods = [];
    this.selectedItem = undefined;

    this.addOptionListeners = function () {
      const that = this;
      const options = this.$options.children();
      for (let ii = 0, nn = options.length; ii < nn; ii++) {
        const option = options[ii];
        const link = $(option).children();
        link.click((event) => {
          event.preventDefault();
          const text = event.target.innerHTML;
          that.setSelectedText(text);
          const period = that.getPeriod(text);
          that.appendOptions(period);
          that.selectedItem = period;
          const params = {selection: period};
          that.trigger(SELECTION_CHANGED, params);
        });
      }
    };

    this.appendOptions = function (selectedPeriod) {
      this.$options.empty();
      const periods = this.periods;
      for (let ii = 0, nn = periods.length; ii < nn; ii++) {
        const period = periods[ii];
        if (period.slug !== selectedPeriod.slug) {
          const label = this.getLabel(period);
          const option = this.getOption(label);
          this.$options.append(option);
        }
      }
      this.addOptionListeners();
    };

    this.getLabel = function () {
      // Override
    };

    this.getOption = function (label) {
      return `<li><a href="#">${label}</a></li>`;
    };

    this.getPeriod = function () {
      // Override
    };

    this.getPeriods = function () {
      // Override
    };

    this.getSelectedItem = function () {
      return this.selectedItem;
    };

    this.lock = function () {
      this.$el.css('pointer-events', 'none');
      this.$el.children().remove('ul');
      this.$el
        .find('a')
        .css('background', 'rgba(0, 0, 0, 0)')
        .css('boxShadow', 'none');
    };

    this.setSelectedText = function (label) {
      this.$selected.css('cursor', 'pointer').text(label.toLowerCase());
    };

    Backbone.View.apply(this, args);
  },
});
